
import LineChart from '@/components/charts/LineCart.vue';
import { defineComponent } from 'vue';
export default defineComponent({
  components: {
    LineChart
  }
})
